export default "__VITE_ASSET__GzoeZAo5__"